import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { api } from '../services/api';

export function useFeatureFlag(flagKey) {
  const { user } = useAuth();
  const [state, setState] = useState({ enabled: false, loading: true });

  useEffect(() => {
    // Handle null/undefined flagKey
    if (!flagKey) {
      setState({ enabled: false, loading: false });
      return;
    }

    (async () => {
      try {
        const flag = await api.getFeatureFlag(flagKey);

        // If flag is fully enabled, everyone has access
        if (flag.enabled === true) {
          setState({ enabled: true, loading: false });
          return;
        }

        // If flag is disabled, check if user's role is in enabled_for_roles
        if (flag.enabled === false && flag.enabled_for_roles && Array.isArray(flag.enabled_for_roles)) {
          const hasAccess = flag.enabled_for_roles.includes(user?.role);
          setState({ enabled: hasAccess, loading: false });
          return;
        }

        // Fallback: flag off
        setState({ enabled: false, loading: false });
      } catch {
        // 404 or error → flag off
        setState({ enabled: false, loading: false });
      }
    })();
  }, [flagKey, user?.role]);

  return state;
}
